<div class="flex justify-between h-full p-4">
    <div class="flex gap-2">
        <div class="text-[16px] font-black content-center">
            <span> {{ primaryLabel() }} </span>
        </div>
        <div
            class="text-sm text-dat-grey-500 content-center"
        >  
            @if(displaySecondaryLabel()) {
                <span> {{ secondaryLabel() }} </span>
            }
        </div>
    </div>
    <button class="rounded-full bg-white  text-dat-blue-700 px-3 py-2"
        [attr.data-testid]="closeSearchId()"
        (click)="closeSearch()"
        >
            <div class="text-sm text-dat-blue-700">CLOSE SEARCH</div>
    </button>
</div>